import { FadeOut, ZoomOut } from "slotworks/graphics/animation/base-animations";
import Layers from "slotworks/graphics/layers/layers";
import SoundManager from "slotworks/sound/sound-manager";
import Contract from "slotworks/utils/contract";
import Point from "slotworks/utils/geom/point";
import { parallel, sequence } from "slotworks/utils/race-utils";
import Timer from "slotworks/utils/timer";
import * as TweenJS from "slotworks/utils/tween";
import RevolverWinTransitions from "./revolver-win-transitions";
import soundManager from "slotworks/sound/sound-manager";
import Components from "slotworks/components/components";
import gameState from "slotworks/model/game-state";
import { StartBaseMusic } from "commands/music";

export default class MegaWinTransitions extends RevolverWinTransitions {
    public EXPLOSION_TIME: number = 400;
    public TEXT_ZOOM: number = 0.9;

    private mega: PIXI.Sprite;

    public in(): Contract<void> {
        return new Contract((resolve) => {

            this.mega = Layers.CelebrationContent.getSprite("mega");
            this.mega.visible = false;

            this.inResolve = resolve;

            setTimeout(() => {
                RevolverWinTransitions.glitter.emit = true;
                this.titleIn(this.mega, new Point(0.5, 1)).then(() => {
                    if (RevolverWinTransitions.currentTiers.length > 2)
                        this.hoverTitleBigWin(this.mega, 2);
                    else
                        this.endlessHover(this.mega);
                    this.resolveIn();
                })
            }, 100);
        });
    }

    public skipIn() {
        this.destroy();
        RevolverWinTransitions.winValue.visible = true;
        this.endlessHover(this.mega);
        SoundManager.customEvent("mega_win");
        this.setTextSize(this.TEXT_ZOOM);
        // RevolverWinTransitions.glitter.emit = true;
        this.resolveIn();
    }

    public out(): Contract<void> {
        RevolverWinTransitions.removeOrientationChange();
        return parallel([
            () => this.zoomOutStacks(),
            () => sequence([
                () => Contract.wrap(() => {
                    TweenJS.removeAll(RevolverWinTransitions.winValue.scale);
                    const totalWin = gameState.getCurrentGame().totalCreditsWon;
                    Components.betBar.winnings.setWinnings(totalWin, totalWin, 750);
                    RevolverWinTransitions.glitter.emit = false;
                    soundManager.customEvent("plaque_transition");
                }),
                () => parallel([
                    () => ZoomOut(RevolverWinTransitions.winValue, 50),
                    () => this.titleOut(this.mega, new Point(0.5, 1), 50)
                ]),
                () => Contract.wrap(() => {
                    TweenJS.removeAll(this.mega.scale);
                    TweenJS.removeAll(this.mega);
                    TweenJS.removeAll(RevolverWinTransitions.winValue.scale);
                    this.mega.visible = false;
                    soundManager.customEvent("celebration_end");
                    // soundManager.customEvent("base_reels_background_start");
                    StartBaseMusic(true);
                }),
                () => FadeOut(RevolverWinTransitions.background, this.BOUNCE_TIME),
                () => Contract.getTimeoutContract(750)
            ])
        ]);
    }

    public destroy() {
        this.clearTimers();

        TweenJS.removeAll(this.mega.scale);
        TweenJS.removeAll(this.mega);

        super.destroy();
    }
}
